var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldChartFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.79 2.03c-.2-.02-.4-.03-.6-.03H7.81A5.812 5.812 0 0 0 2 7.81v8.38A5.812 5.812 0 0 0 7.81 22H14c.55 0 1-.45 1-1v-2.97c0-1.67 1.36-3.03 3.03-3.03H21c.55 0 1-.45 1-1V7.81a5.812 5.812 0 0 0-5.21-5.78zM7 14.25c-.41 0-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75zm5 0c-.41 0-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.03 16c-1.27 0-2.03.76-2.03 2.03v2.94c0 1.27.76 2.03 2.03 2.03h2.94c1.27 0 2.03-.76 2.03-2.03v-2.94c0-1.27-.76-2.03-2.03-2.03h-2.94zm3.44 5.47c-.13.12-.3.18-.46.18-.16 0-.33-.06-.46-.18l-1.06-1.06-1.04 1.06c-.13.12-.29.18-.47.18-.15 0-.32-.06-.44-.18a.646.646 0 0 1 0-.91l1.06-1.06-1.06-1.05a.646.646 0 0 1 0-.91c.25-.25.66-.25.91 0l1.04 1.06 1.06-1.06c.25-.25.67-.25.92 0s.25.66 0 .91l-1.06 1.05 1.06 1.06c.25.25.25.66 0 .91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldChartFail);
export default __webpack_public_path__ + "static/media/vuesax-bold-chart-fail.c1922753d199146808906426d8483388.svg";
export { ForwardRef as ReactComponent };